import type { MovieType } from "./movies";

export interface CategoryInfo {
  key: MovieType;
  name: string;
  icon: string;
  desc: string;
}

export const categoryInfo: CategoryInfo[] = [
  {
    key: "movie",
    name: "电影",
    icon: "ri-film-line",
    desc: "院线佳片与经典类型片，动作、科幻、悬疑一次看个够。",
  },
  {
    key: "tv",
    name: "电视剧",
    icon: "ri-tv-2-line",
    desc: "热播国剧与精品剧集，追剧更新、口碑好剧实时掌握。",
  },
  {
    key: "variety",
    name: "综艺",
    icon: "ri-mic-line",
    desc: "美食、音乐、旅行与竞技综艺，轻松一刻就在此处。",
  },
];

export const genreOptions: Record<string, string[]> = {
  movie: ["全部", "动作", "科幻", "悬疑", "犯罪", "奇幻", "爱情", "喜剧", "剧情", "古装", "惊悚", "冒险"],
  tv: ["全部", "悬疑", "都市", "古装", "探案", "医疗", "职场", "年代", "历史", "青春", "家庭", "罪案"],
  variety: ["全部", "美食", "真人秀", "音乐", "竞演", "旅行", "户外", "竞技", "答题", "生活"],
};

export const regionOptions = [
  "全部",
  "中国大陆",
  "中国香港",
  "中国台湾",
  "美国",
  "日本",
  "韩国",
  "英国",
];

export const yearOptions = ["全部", "2026", "2025", "2024", "2023", "更早"];

export const typeLabels: Record<MovieType, string> = {
  movie: "电影",
  tv: "电视剧",
  variety: "综艺",
};

export const sortOptions = [
  { key: "updated", label: "按更新时间" },
  { key: "rating", label: "按评分" },
  { key: "year", label: "按年份" },
];

export const featuredTopics = [
  {
    id: "topic-1",
    title: "国产科幻新浪潮",
    subtitle: "从《星际回响》看东方科幻的想象力",
    desc: "当工业能力遇上本土叙事，一批华语科幻作品正以不同于好莱坞的姿态，讲述属于我们自己的宇宙。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20deep%20space%20nebula%20with%20golden%20starlight%20and%20distant%20planet%2C%20epic%20science%20fiction%20concept%20art%2C%20warm%20gold%20and%20navy%20palette%2C%20no%20text&width=800&height=600&seq=topic-cover-1&orientation=landscape",
    tag: "编辑精选",
  },
  {
    id: "topic-2",
    title: "悬疑罪案 · 深夜片单",
    subtitle: "适合一个人看的十部作品",
    desc: "雨天、霓虹、旧案与真相。我们把近期最值得反复回味的悬疑罪案作品整理成一份深夜片单。",
    cover:
      "https://readdy.ai/api/search-image?query=Neon%20lit%20rainy%20city%20street%20at%20night%20with%20mysterious%20atmosphere%2C%20moody%20teal%20and%20amber%20cinematic%20tone%2C%20concept%20art%2C%20no%20text&width=800&height=600&seq=topic-cover-2&orientation=landscape",
    tag: "专题合集",
  },
  {
    id: "topic-3",
    title: "下饭综艺清单",
    subtitle: "让厨房与舞台陪你度过夜晚",
    desc: "从烟火气十足的美食真人秀，到燃到起鸡皮疙瘩的音乐竞演，这份清单专治“吃饭不知道看什么”。",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20warm%20kitchen%20and%20concert%20stage%20blended%20scene%2C%20warm%20orange%20and%20amber%20lights%2C%20joyful%20variety%20show%20concept%20art%2C%20no%20text&width=800&height=600&seq=topic-cover-3&orientation=landscape",
    tag: "生活娱乐",
  },
];